export default "__VITE_ASSET__Ch$DHKfD__"